export enum MatThemeColor {
    PRIMARY = 'primary',
    ACCENT = 'accent',
    WARN = 'warn',
}
